import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useSetState } from 'ahooks'
import {
  SActionBtn,
  SBack,
  SDrawerOrModal,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { Button, message, Upload } from 'antd'
import {
  addDiscountRatioManage,
  deletedBatchByIdsDiscountRatioManage,
  deleteDiscountRatioManage,
  discountRatioManagePage,
  importFileDeleteDiscount,
  updateDiscountRatioManage,
} from '@/services/product.ts'
import { config } from './config.tsx'
import { AddOrEditStandard } from './addOrEdit.tsx'
import { useParams, useSearchParams } from 'react-router-dom'
import { apiData2Table } from '@/utils/data.ts'
import { DownloadOutlined, UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import { httpOrgList, getRoleList } from '@/services/homeService.ts'

export const DiscountFactor = forwardRef((props, ref) => {
  const { genItemId } = useParams()
  const [searchParams] = useSearchParams({})
  const readOnly = searchParams.get('readOnly')
  const listRef = useRef()
  const editRef = useRef()

  const [state, setState] = useSetState({
    visible: false,
    record: {},
    btnLoading: false,
    exportLoading: false,
    importLoading: false,
    loading: false,
    companyList: [],
  })

  useImperativeHandle(ref, () => {
    return { getData: () => listRef.current?.getDataSource() }
  })
  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      query.orderBys = [
        {
          columnName: 'id',
          asc: false,
        },
      ]
      query.searchFlag = true
      discountRatioManagePage({
        params: { pageId: current, pageSize },
        data: { ...query },
      })
        .then(res => {
          res.list = res.list?.map((item, index) => {
            return {
              ...item,
              orderNumber: index + 1,
            }
          })
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    setState({ visible: true, record })
  }

  const onDel = record => {
    SMessage.confirm({
      onOk: () => {
        return deleteDiscountRatioManage(record.id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }
  const onImport = (upload: any) => {
    setState({ importLoading: true })
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    return importFileDeleteDiscount(data)
      .then((res: any) => {
        listRef.current && listRef.current.reload()
        onSuccess && onSuccess()
        message.success(res.message || '导入成功')
      })
      .catch(onError)
      .finally(() => setState({ importLoading: false }))
  }

  const onExport = () => {
    setState({ exportLoading: true })
    fileDownload(UrlConfig.PlusProductWeb.DownloadDiscountRatioManage)
      .then(() => setState({ exportLoading: false }))
      .catch(() => setState({ exportLoading: false }))
  }
  const getOptions = () => {
    return new Promise(async (resolve, reject) => {
      const companyList: any = await httpOrgList()
      const roleList = await getRoleList({ data: { enabled: true } })
      resolve({
        companyList: [{ name: '通用', id: '0' }, ...companyList],
        roleList: roleList,
      })
    })
  }
  const onBatchDelete = ({ selectedRowKeys }) => {
    SMessage.confirm({
      content: `是否确认删除所选数据`,
      onOk: () => {
        return deletedBatchByIdsDiscountRatioManage({
          data: { idList: selectedRowKeys, enabled: true },
        }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: { onAdd, onBatchDelete },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {readOnly ? (
              <SActionBtn onClick={() => onEdit(record)}>详情</SActionBtn>
            ) : (
              [
                <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>,
                <SActionBtn danger onClick={() => onDel(record)}>
                  删除
                </SActionBtn>,
              ]
            )}
          </STableActions>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={state.importLoading}
              disabled={state.importLoading}
              icon={<UploadOutlined />}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
            disabled={state.exportLoading}
            loading={state.exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
    },
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const onSubmit = () => {
    editRef.current?.onFinish()
  }

  const onSubmitOk = values => {
    const apiUrl = values.id ? updateDiscountRatioManage : addDiscountRatioManage
    apiUrl(values)
      .then((res: any) => {
        message.success(res.message || '操作成功')
        listRef.current?.reload()
        onCancel()
      })
      .finally(() => {
        setState({ btnLoading: false })
      })
  }

  return (
    <>
      {/* <div style={{ paddingTop: 10, paddingLeft: 10, backgroundColor: '#fff', color: 'gray' }}>
        <ExclamationCircleOutlined style={{ margin: '0px 5px', color: '#1677FF' }} />
        说明：优惠系数用于设置不同角色在报价中操作优惠的比例上限，优惠系数=1-(优惠汇总金额+材料优惠金额)/工程总造价。
      </div> */}
      <SLowcodeList
        searchMode={'group'}
        ref={listRef}
        config={{ ...config, footer: readOnly ? [] : config.footer }}
        {...extensions}
      />
      <SDrawerOrModal
        title={state.record.id ? '编辑' : '新增' + '优惠'}
        width={500}
        open={state.visible}
        onOk={onSubmit}
        antdProps={readOnly ? { footer: null } : {}}
        loading={state.btnLoading}
        onCancel={onCancel}
      >
        {state.visible && (
          <AddOrEditStandard
            record={state.record}
            ref={editRef}
            fn={onSubmitOk}
            setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          />
        )}
      </SDrawerOrModal>
    </>
  )
})
